import {
  ButtonChildrenContainer,
  HeaderContainer,
  HeaderRightContainer,
  ProjectListTypeButtonContainer,
  Title
} from '../styled-component'
import { FormattedMessage, useIntl } from 'react-intl'
import ButtonComponent from '../../../components/stories/atoms/button'
import { buttonVariantOptions } from '../../../components/stories/atoms/button/constants'
import {
  NewProject,
  NewFolder
} from '../../../components/stories/atoms/icons/entities'
import {
  Viewlist,
  ViewTale
} from '../../../components/stories/atoms/icons/core'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'
import { viewTypeOptions } from '../constants'
import { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { useMeQuery } from '../../../react-query/authentication/query/use-me-query'
import { useProjectMenuListViewControl } from '../../../hooks/use-project-menu-list-view-control'
import { useProjectMenuStore } from '../../../zustand/project-menu/use-project-menu-store'
import { trackFirebaseEvent } from '../../../firebase/firebase-analytics'
import ListViewButton from '../../../components/list-view-button'

const ProjectMenuHeader = () => {
  const history = useHistory()
  const { formatMessage } = useIntl()
  const { data: user } = useMeQuery()

  const pageTitle = useProjectMenuStore((state) => state.pageTitle)
  const tileViewFolderHistory = useProjectMenuStore(
    (state) => state.tileViewFolderHistory
  )

  const definePageTitle =
    pageTitle ?? formatMessage({ id: 'projects_projects' })

  const { viewType, tab } = useProjectMenuListViewControl()
  const userPermissions = user?.permissions ?? []
  const canCreateProjects = userPermissions.includes('CreateProjects')
  const canCreateFolders = userPermissions.includes('CreateProjectFolders')

  const isActive = (type) => viewType === type

  const handleShowListView = useCallback(() => {
    history.push(`/project?view=${viewTypeOptions.LIST_VIEW}&tab=${tab}`)

    trackFirebaseEvent('project_list_view_list_selected', {
      source: 'project_list'
    })
  }, [history, tab])

  const handleShowTileView = useCallback(() => {
    history.push(`/project?view=${viewTypeOptions.TILE_VIEW}&tab=${tab}`)

    trackFirebaseEvent('project_list_view_tile_selected', {
      source: 'project_list'
    })
  }, [history, tab])

  const handleOpenCreateProjectModal = useCallback(() => {
    const hasTitleViewFolderHistory = tileViewFolderHistory.length > 0

    history.push(
      `/project/new${hasTitleViewFolderHistory ? `/${tileViewFolderHistory.at(-1)?.id}` : ''}?view=${viewType}&tab=${tab}`
    )

    trackFirebaseEvent('project_create_start', {
      source: 'project_list'
    })
  }, [history, viewType, tab, tileViewFolderHistory])

  const handleOpenCreateFolderModal = useCallback(() => {
    const hasTitleViewFolderHistory = tileViewFolderHistory.length > 0

    history.push(
      `/project/newfolder${hasTitleViewFolderHistory ? `/${tileViewFolderHistory.at(-1)?.id}` : ''}?view=${viewType}&tab=${tab}`
    )
  }, [history, viewType, tab, tileViewFolderHistory])

  const listButtons = useMemo(
    () => [
      {
        type: viewTypeOptions.LIST_VIEW,
        icon: Viewlist,
        isLeft: true,
        onClick: handleShowListView
      },
      {
        type: viewTypeOptions.TILE_VIEW,
        icon: ViewTale,
        onClick: handleShowTileView
      }
    ],
    [handleShowListView, handleShowTileView]
  )

  return (
    <HeaderContainer>
      <Title>{definePageTitle}</Title>

      <HeaderRightContainer>
        {canCreateProjects && (
          <ButtonComponent
            variant={buttonVariantOptions.PRIMARY}
            onClick={handleOpenCreateProjectModal}
          >
            <ButtonChildrenContainer>
              <NewProject />
              <FormattedMessage id="create_project" />
            </ButtonChildrenContainer>
          </ButtonComponent>
        )}

        {canCreateFolders && (
          <ButtonComponent
            variant={buttonVariantOptions['TERTIARY-WHITE-FILL']}
            onClick={handleOpenCreateFolderModal}
          >
            <ButtonChildrenContainer>
              <NewFolder specialStroke={colorsOptions.docuToolsOrange.orange} />
              <FormattedMessage id="create_folder" />
            </ButtonChildrenContainer>
          </ButtonComponent>
        )}

        <ProjectListTypeButtonContainer>
          {listButtons.map(({ type, icon, isLeft, onClick }) => (
            <ListViewButton
              key={type}
              Icon={icon}
              isLeft={isLeft}
              isActive={isActive(type)}
              onClick={onClick}
            />
          ))}
        </ProjectListTypeButtonContainer>
      </HeaderRightContainer>
    </HeaderContainer>
  )
}

export default ProjectMenuHeader
